<seal-loading-bar></seal-loading-bar>

<seal-vertical-navigation
  class="bg-white print:hidden"
  [mode]="isScreenSmall() ? 'over' : 'side'"
  [name]="'mainNavigation'"
  [navigation]="navigation().default"
  [opened]="!isScreenSmall()">
  <ng-container sealVerticalNavigationContentHeader>
    <div class="flex h-20 items-center p-6 pb-0">
      <img class="w-30 dark:hidden" alt="" [src]="environment.LOGO_TEXT" />

      <img class="hidden w-30 dark:flex" alt="" [src]="environment.LOGO_TEXT_DARK" />
    </div>
  </ng-container>

  <ng-container sealVerticalNavigationContentFooter>
    <div class="mb-4 mt-2 flex h-16 flex-0 items-center justify-center px-6 opacity-12">
      <img class="max-w-36" alt="" [src]="environment.LOGO_TEXT_DARK" />
    </div>
  </ng-container>
</seal-vertical-navigation>

<div class="flex w-full min-w-0 flex-auto flex-col">
  <div class="bg-card relative z-49 flex h-16 w-full flex-0 items-center px-4 shadow dark:border-b dark:shadow-none md:px-6">
    <button mat-icon-button (click)="toggleNavigation('mainNavigation')">
      <mat-icon [svgIcon]="'heroicons_outline:bars-3'"></mat-icon>
    </button>

    <div class="ml-auto flex items-center space-x-0.5 pl-2 sm:space-x-2">
      <seal-fullscreen class="hidden md:block" [tooltip]="'button.fullscreen' | transloco"></seal-fullscreen>

      <!-- <theme></theme>-->

      <!--      <language></language>-->

      <profile></profile>
    </div>
  </div>

  <div class="flex flex-auto flex-col">
    @if (true) {
      <router-outlet></router-outlet>
    }
  </div>
</div>
